import React from "react";
import {
  gridTwoCol,
  inputClass,
  labelClass,
  sectionCardClass,
  sectionTitleClass,
} from "./tenantDetailStyles";
import LanguageMultiSelect from "../../../components/admin/tenants/LanguageMultiSelect";

export default function TenantStammdatenEditForm({
  form,
  setField,
  setLanguages,
  saving,
  saveError,
  onSubmit,
}) {
  return (
                <form onSubmit={onSubmit}>
                  <div className={sectionCardClass}>
                    <div className={sectionTitleClass}>Stammdaten</div>
                    <div style={gridTwoCol}>
                      <div>
                        <label htmlFor="td-fn" className={labelClass}>
                          Vorname *
                        </label>
                        <input
                          id="td-fn"
                          className={inputClass}
                          value={form.firstName}
                          onChange={setField("firstName")}
                          disabled={saving}
                        />
                      </div>
                      <div>
                        <label htmlFor="td-ln" className={labelClass}>
                          Nachname *
                        </label>
                        <input
                          id="td-ln"
                          className={inputClass}
                          value={form.lastName}
                          onChange={setField("lastName")}
                          disabled={saving}
                        />
                      </div>
                    </div>
                    <div style={{ marginTop: "10px" }}>
                      <label htmlFor="td-bd" className={labelClass}>
                        Geburtsdatum
                      </label>
                      <input
                        id="td-bd"
                        type="date"
                        className={inputClass}
                        value={form.birthDate}
                        onChange={setField("birthDate")}
                        disabled={saving}
                      />
                    </div>
                    <div style={{ marginTop: "10px" }}>
                      <label htmlFor="td-nat" className={labelClass}>
                        Nationalität
                      </label>
                      <input
                        id="td-nat"
                        className={inputClass}
                        value={form.nationality}
                        onChange={setField("nationality")}
                        disabled={saving}
                      />
                    </div>
                  </div>
                  <div className={sectionCardClass}>
                    <div className={sectionTitleClass}>Aufenthalt</div>
                    <div style={{ marginBottom: "10px" }}>
                      <label htmlFor="td-swiss" className={labelClass}>
                        Schweizer/in
                      </label>
                      <select
                        id="td-swiss"
                        className={inputClass}
                        style={{ cursor: saving ? "default" : "pointer" }}
                        value={
                          form.isSwiss === null
                            ? ""
                            : form.isSwiss === true
                              ? "true"
                              : "false"
                        }
                        onChange={setField("isSwiss")}
                        disabled={saving}
                      >
                        <option value="">Unbekannt</option>
                        <option value="true">Ja</option>
                        <option value="false">Nein</option>
                      </select>
                    </div>
                    {form.isSwiss !== true ? (
                      <div style={{ marginTop: "10px" }}>
                        <label htmlFor="td-permit" className={labelClass}>
                          Aufenthaltsbewilligung
                        </label>
                        <select
                          id="td-permit"
                          className={inputClass}
                          style={{ cursor: saving ? "default" : "pointer" }}
                          value={form.residencePermit}
                          onChange={setField("residencePermit")}
                          disabled={saving}
                        >
                          <option value="">—</option>
                          <option value="B">B</option>
                          <option value="C">C</option>
                          <option value="L">L</option>
                          <option value="G">G</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    ) : null}
                  </div>
                  <div className={sectionCardClass}>
                    <div className={sectionTitleClass}>Kontakt</div>
                    <div style={{ marginBottom: "10px" }}>
                      <label htmlFor="td-email" className={labelClass}>
                        E-Mail
                      </label>
                      <input
                        id="td-email"
                        type="email"
                        className={inputClass}
                        value={form.email}
                        onChange={setField("email")}
                        disabled={saving}
                      />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                      <label htmlFor="td-phone" className={labelClass}>
                        Telefon
                      </label>
                      <input
                        id="td-phone"
                        className={inputClass}
                        value={form.phone}
                        onChange={setField("phone")}
                        disabled={saving}
                      />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                      <label htmlFor="td-company" className={labelClass}>
                        Firma
                      </label>
                      <input
                        id="td-company"
                        className={inputClass}
                        value={form.company}
                        onChange={setField("company")}
                        disabled={saving}
                      />
                    </div>
                    {/*
                      Lives in the existing "Kontakt" section rather than a new
                      card of its own: it is a preference about mail to this
                      person, next to the address that mail would go to. A
                      section called "Kommunikation" or "Automatisierung" would
                      be a home for the next opt-out and the one after that,
                      which is exactly the generic switch this field must not
                      become.

                      Checked = opted OUT. The label says what checking it does
                      ("Keine … senden"), so the box and the sentence agree and
                      nobody has to invert anything in their head.
                    */}
                    <label
                      htmlFor="td-bday-optout"
                      className="flex items-start gap-2 text-[12px] text-[#8892b0]"
                      style={{ marginBottom: "10px", cursor: saving ? "default" : "pointer" }}
                    >
                      <input
                        id="td-bday-optout"
                        type="checkbox"
                        checked={form.birthdayEmailOptOut === true}
                        onChange={setField("birthdayEmailOptOut")}
                        disabled={saving}
                        className="mt-0.5"
                      />
                      <span>
                        <span className="text-[#edf0f7]">
                          Keine Geburtstags-E-Mail senden
                        </span>
                        <span style={{ display: "block", marginTop: "2px" }}>
                          Wenn aktiviert, erhält dieser Mieter keine
                          automatischen Geburtstagsgrüsse. Andere wichtige
                          E-Mails bleiben davon unberührt.
                        </span>
                      </span>
                    </label>
                  </div>
                  <div className={sectionCardClass}>
                    <div className={sectionTitleClass}>Sprachen</div>
                    <div style={{ marginTop: "10px" }}>
                      <LanguageMultiSelect
                        value={form.languages || []}
                        onChange={setLanguages}
                        disabled={saving}
                      />
                    </div>
                  </div>
                  <div className={sectionCardClass}>
                    <div className={sectionTitleClass}>Finanzen</div>
                    <div style={{ marginTop: "10px" }}>
                      <label htmlFor="td-iban" className={labelClass}>
                        IBAN
                      </label>
                      <input
                        id="td-iban"
                        className={inputClass}
                        value={form.iban || ""}
                        onChange={setField("iban")}
                        placeholder="CH.."
                        disabled={saving}
                      />
                    </div>
                  </div>
                  <div className={sectionCardClass}>
                    <div className={sectionTitleClass}>Adresse</div>
                    <div style={{ marginBottom: "10px" }}>
                      <label htmlFor="td-street" className={labelClass}>
                        Strasse
                      </label>
                      <input
                        id="td-street"
                        className={inputClass}
                        value={form.street}
                        onChange={setField("street")}
                        disabled={saving}
                      />
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: "10px" }}>
                      <div>
                        <label htmlFor="td-plz" className={labelClass}>
                          PLZ
                        </label>
                        <input
                          id="td-plz"
                          className={inputClass}
                          value={form.postalCode}
                          onChange={setField("postalCode")}
                          disabled={saving}
                        />
                      </div>
                      <div>
                        <label htmlFor="td-city" className={labelClass}>
                          Ort
                        </label>
                        <input
                          id="td-city"
                          className={inputClass}
                          value={form.city}
                          onChange={setField("city")}
                          disabled={saving}
                        />
                      </div>
                    </div>
                    <div style={{ marginTop: "10px", marginBottom: "12px" }}>
                      <label htmlFor="td-country" className={labelClass}>
                        Land
                      </label>
                      <input
                        id="td-country"
                        className={inputClass}
                        value={form.country}
                        onChange={setField("country")}
                        disabled={saving}
                      />
                    </div>

                    {saveError ? (
                      <div style={{ marginBottom: "12px", fontSize: "13px", color: "#f87171" }}>
                        {saveError}
                      </div>
                    ) : null}
                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                      <button
                        type="submit"
                        disabled={saving}
                        className={`rounded-[8px] bg-gradient-to-r from-[#5b8cff] to-[#7c5cfc] px-3.5 py-2 text-sm font-semibold text-white ${
                          saving ? "cursor-default opacity-50" : "cursor-pointer"
                        }`}
                        style={{ border: "none" }}
                      >
                        {saving ? "Speichern …" : "Speichern"}
                      </button>
                    </div>
                  </div>
                  </form>
  );
}
